import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import ProjectCard from './ProjectCard';

const ProjectShowcase = () => {
  const { t, projects } = useLanguage();

  const workProjects = Object.values(projects).filter((p) => p.type === 'Work');

  return (
    <section className="section section--tint">
      <div className="wrap split">
        <h2 className="split__label">{t('projectShowcaseTitle')}</h2>
        <div>
          <p className="prose">{t('projectShowcaseSubtitle')}</p>
          <ul className="index index--spaced">
            {workProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </ul>
          <p className="index-foot">
            <Link to="/projects" className="btn btn-secondary">
              {t('viewAllProjects')}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProjectShowcase;
